import React, { useState, useEffect, Fragment } from "react";
import companyLogo from "../../assets/images/color-app-logo.svg";

const Footer = () => {
	return (
		<Fragment>
			<footer className="bg-white shadow-[0_0_0.4rem_rgba(0,0,0,0.1)] py-4 w-full mt-auto">
				<div className="flex items-center  justify-center text-center">
					<span>
						Copyright © {new Date().getFullYear()} . Powered By
					</span>
					<img
						src={companyLogo}
						alt="logo"
						width={50}
						height={30}
						className="mx-3"
					/>
				</div>
			</footer>
		</Fragment>
	);
};

export default Footer;
